import { Icon, Tooltip } from '@atom/mui';
import colors from '@atom/styles/colors';
import { WorkCollectionItem } from '@atom/types/work';

export interface Props {
  title: string;
  workOrdersDictionary: { [key: string]: WorkCollectionItem };
}

const WorkCalendarEvent = ({ title, workOrdersDictionary }: Props) => {
  // Due to library constraints with passing props per event,
  // title is equal to the workOrder's id.
  const wo = workOrdersDictionary[title] as any;
  const isPm = wo?.source === 'PM' || wo?.isPmProjection;
  const isProjection = wo?.isPmProjection;
  return (
    <span
      style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }}
    >
      {isPm && (
        <Tooltip title={isProjection ? 'Projected PM' : 'PM-generated work'}>
          <Icon
            style={{
              fontSize: '1.125rem',
              color: colors.opacity.white0_8,
              opacity: isProjection ? 0.6 : 1,
              verticalAlign: 'middle',
            }}
          >
            autorenew
          </Icon>
        </Tooltip>
      )}
      <span>{wo?.name ?? title}</span>
    </span>
  );
};

export default WorkCalendarEvent;
